import React, { useState, useEffect } from "react";
import {Col, Row, DatePicker, Checkbox} from 'antd';
import InputField from '../../../../input-field';
import SelectField from '../../../../select-field';
import FieldBlock from '../../../../field-block';
import i18n from "../../../../../i18n";

export default function FirstStep({ stepFields, setFields, getFieldErrors, organisationFormsList, countryList, taxTypes, reindexedTaxTypes, edit = false }) {
    const ndsList = [
        {
            Id: 1,
            Name: i18n.t('constants.ndsList.1')
        },
        {
            Id: 2,
            Name: i18n.t('constants.ndsList.2')
        }
    ];

    const [notRegisteredATI, setNotRegisteredATI] = useState(false);
    const [taxId, setTaxId] = useState(stepFields.taxId);

    useEffect(() => {
        if (stepFields.workWithNds === 2) {
            setFields({...stepFields,
                taxPercent: 0,
                taxType: 'no_nds'
            });
            setTaxId(null);
        }
    }, [stepFields.workWithNds]);

    return (
        <>
            <Row>
                <Col lg={8} sm={24}>
                    <InputField
                        name="name"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.name.title')}
                        required={true}
                        value={stepFields.name}
                        setValue={(value) => {setFields({...stepFields, name: value});}}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <FieldBlock name="dateRegistration" title={i18n.t('modals.modalEditLegalEntityNew.fields.dateRegistration.title')} getErrors={getFieldErrors}>
                        <DatePicker
                            style={{ width: "100%" }}
                            value={stepFields.dateRegistration}
                            defaultValue={stepFields.dateRegistration}
                            format="DD.MM.YYYY"
                            size="large"
                            name="dateRegistration"
                            onChange={value => setFields({...stepFields, dateRegistration:  value})}
                        />
                    </FieldBlock>
                </Col>
            </Row>
            <Row>
                <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField name="inn" label={i18n.t('modals.modalEditLegalEntityNew.fields.inn.title')} value={stepFields.inn} setValue={value => setFields({...stepFields, inn: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                </Col>
                { stepFields.orgFormId === 1 ? (
                    <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField name="ogrnip" label={i18n.t('modals.modalEditLegalEntityNew.fields.ogrnip.title')}   value={stepFields.ogrnip} setValue={value => setFields({...stepFields, ogrnip: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                    </Col>
                ) : (
                    <>
                        <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                            <InputField name="kpp" label={i18n.t('modals.modalEditLegalEntityNew.fields.kpp.title')} value={stepFields.kpp} setValue={value => setFields({...stepFields, kpp: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                        </Col>
                        <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                            <InputField name="ogrn" label={i18n.t('modals.modalEditLegalEntityNew.fields.ogrn.title')} value={stepFields.ogrn} setValue={value => setFields({...stepFields, ogrn: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                        </Col>
                    </>
                )}
                <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField name="okpo" label={i18n.t('modals.modalEditLegalEntityNew.fields.okpo.title')} value={stepFields.okpo} setValue={value => setFields({...stepFields, okpo: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                </Col>
                <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                    <SelectField
                        title={i18n.t('modals.modalEditLegalEntityNew.fields.reason.title')}
                        name="legalReason"
                        selectedValue={stepFields.workWithNds}
                        values={ndsList}
                        onChange={(value) => {
                            setFields({
                                ...stepFields,
                                workWithNds: value,
                            });
                        }}
                        getErrors={getFieldErrors}
                        placeholder={i18n.t('modals.modalEditLegalEntityNew.fields.reason.placeholder')}
                        notFoundText={null}
                        showArrow={true}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col lg={8} sm={24} >
                    {(stepFields.workWithNds === 1) && <SelectField
                        title={i18n.t('modals.modalEditLegalEntityNew.fields.tax.title')}
                        name="tax"
                        selectedValue={taxId}
                        values={taxTypes}
                        getErrors={getFieldErrors}
                        onChange={(value) => {
                            setTaxId(value);
                            setFields({...stepFields,
                                taxPercent: reindexedTaxTypes[value].percent,
                                taxType: reindexedTaxTypes[value].type
                            });
                        }}
                        placeholder={i18n.t('modals.modalEditLegalEntityNew.fields.tax.placeholder')}
                        notFoundText={i18n.t('modals.modalEditLegalEntityNew.fields.tax.notFoundText')}
                        style={{ width: "100%" }}
                    />}
                </Col>
            </Row>
            <Row>
                <Col lg={8} sm={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField
                        name="atiCode"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.atiCode.title')}
                        value={stepFields.atiCode}
                        isDisabled={notRegisteredATI}
                        setValue={value => setFields({...stepFields, atiCode: value})}
                        getFieldErrors={getFieldErrors}
                    />
                    <Checkbox
                        name="accreditedIntDeliveries"
                        checked={notRegisteredATI}
                        onChange={(e) => {
                            setFields({
                                ...stepFields,
                                atiCode: e.target.checked ? i18n.t('modals.modalEditLegalEntityNew.fields.notRegisteredATI.title') : ''
                            });
                            setNotRegisteredATI(e.target.checked)
                        }}
                        style={{fontSize: "10pt", paddingTop: "15px"}}
                    >
                      {i18n.t('modals.modalEditLegalEntityNew.fields.accreditedIntDeliveries.title')}
                    </Checkbox>
                </Col>
            </Row>
        </>
    );
}
